import { useTranslation } from 'react-i18next';

import { Placeholder } from './PlaceHolder';

const MovingLoopPlaceholder = (props: any) => {
  const { t } = useTranslation();

  return (
    <Placeholder
      placeholderText={t('Agentic Workflows only support a loop depth of 3')}
      {...props}
    />
  );
};

export default MovingLoopPlaceholder;
